import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=3faff6b2&scoped=true"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=3faff6b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faff6b2",
  null
  
)

export default component.exports